import { formatMoney } from '@theme/utilities';

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.productUrl = null;
  }

  connectedCallback() {
    this.productUrl = this.dataset.productUrl;

    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    if (event.target instanceof Element) {
      const interactiveElement = event.target.closest(
        'button, input, label, select, [tabindex="1"], a, quick-add-component, add-to-wishlist-button, product-card-swatches, .swatch-button',
      );
      if (interactiveElement) return;
    }

    window.location.href = this.productUrl;
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard);
}

class VariantCard extends HTMLElement {
  connectedCallback() {
    const productCard = this.querySelector('product-card');
    if (!productCard) return;

    this.updateProductUrl(productCard);
    this.updateVariantId(productCard);
    this.updateImage(productCard);
    this.updatePrice(productCard);
    this.updateColorValue(productCard);
  }

  updateProductUrl(productCard) {
    const productUrl = this.dataset.productUrl;
    if (!productUrl) return;

    productCard.dataset.productUrl = productUrl;
    productCard.productUrl = productUrl;

    const groupLink = productCard.querySelector('.product-card-group-link');
    if (groupLink) groupLink.setAttribute('href', productUrl);
  }

  updateVariantId(productCard) {
    const variantId = this.dataset.variantId;
    if (!variantId) return;

    productCard.dataset.variantId = variantId;

    const addToCartButton = productCard.querySelector('[data-ref="add-to-cart-button"]');
    if (addToCartButton) {
  addToCartButton.dataset.variantId = variantId;

  if (this.dataset.variantAvailable === 'false') {
    addToCartButton.disabled = true;

    const content = addToCartButton.querySelector('.button__content');
    if (content) content.textContent = 'En rupture';
    // Mémoriser le style du bouton désactivé.
const computed = window.getComputedStyle(addToCartButton);
const appearance = {};

for (const property of [
  'background-color', 'color', 'opacity', 'box-shadow',
  'border-top-color', 'border-right-color',
  'border-bottom-color', 'border-left-color'
]) {
  appearance[property] = computed.getPropertyValue(property);
}

// Autoriser le clic sans déplacer ni remplacer le bouton.
addToCartButton.disabled = false;
addToCartButton.type = 'button';

for (const [property, value] of Object.entries(appearance)) {
  addToCartButton.style.setProperty(property, value, 'important');
}

addToCartButton.style.setProperty('pointer-events', 'auto', 'important');

if (!addToCartButton.dataset.stockLinkReady) {
  productCard.addEventListener('click', (event) => {
    if (!addToCartButton.contains(event.target)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const url = new URL(
      this.dataset.productUrl || productCard.dataset.productUrl,
      window.location.origin
    );
    url.searchParams.set('variant', this.dataset.variantId);
    window.location.assign(url.href);
  }, true);

  addToCartButton.dataset.stockLinkReady = 'true';
}
addToCartButton.style.setProperty('background', '#bdbdbd', 'important');
addToCartButton.style.setProperty('border-color', '#bdbdbd', 'important');

  }
}
  }

  updateImage(productCard) {
    const variantImage = this.dataset.variantImage;
    if (!variantImage) return;

    const firstImage = productCard.querySelector('product-card-media-gallery img');
    if (!firstImage) return;

    const image200 = variantImage.replace('width=600', 'width=200');
    const image400 = variantImage.replace('width=600', 'width=400');
    firstImage.src = variantImage;
    firstImage.srcset = `${image200} 200w, ${image400} 400w, ${variantImage} 600w`;
  }

  updatePrice(productCard) {
    const variantPrice = parseInt(this.dataset.variantPrice, 10);
    const variantComparePrice = parseInt(this.dataset.variantComparePrice, 10);
    if (Number.isNaN(variantPrice)) return;

    const priceElement = productCard.querySelector('[data-ref="price"]');
    const compareAtPriceElement = productCard.querySelector('[data-ref="compare-at-price"]');

    if (priceElement) {
      priceElement.textContent = formatMoney(variantPrice);
      priceElement.dataset.value = String(variantPrice);
    }

    if (compareAtPriceElement) {
      if (variantComparePrice > variantPrice) {
        compareAtPriceElement.textContent = formatMoney(variantComparePrice);
        compareAtPriceElement.dataset.value = String(variantComparePrice);
      } else {
        compareAtPriceElement.textContent = '';
        compareAtPriceElement.dataset.value = '0';
      }
    }
  }

  updateColorValue(productCard) {
    const colorValue = this.dataset.colorValue;
    if (!colorValue) return;

    const swatchesElements = productCard.querySelectorAll('.swatch-button');
    if (!swatchesElements) return;

    swatchesElements.forEach(swatch => {
      swatch.toggleAttribute('hidden', swatch.dataset.value !== colorValue);
      swatch.removeAttribute('aria-checked');
      if (swatch.dataset.value === colorValue) {
        swatch.setAttribute('aria-checked', 'true');
      }
    });
  }
}

if (!customElements.get('variant-card')) {
  customElements.define('variant-card', VariantCard);
}
